import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TimecardUnsavedStateService {
    private hasPendingTimecardChanges = false;

    setHasPendingTimecardChanges(hasPending: boolean): void {
        this.hasPendingTimecardChanges = hasPending;
    }

    getHasPendingTimecardChanges(): boolean {
        return this.hasPendingTimecardChanges;
    }
}
